// Neu (E26) — der Schlüssel des Auffangkorbs je Bildschirm (App.tsx `Bildschirm`).
//
// Der Korb trägt `key = Schlüssel`: ändert er sich, beginnt der Bildschirm von vorn (Absturz
// vergessen, Zustand weg). Das ist richtig zwischen zwei Bildschirmen — innerhalb der
// Dokumentansicht aber nicht: `/d/X/s/1` → `/d/X/s/2` ist Blättern, kein neuer Bildschirm. Mit
// dem Pfad als Schlüssel verlor jedes Blättern die eingeblendeten Ebenen und die Lage der
// Seitenleiste, und die Leiste lud ihre Vorschaubilder neu an. Darum gilt für `/d/:dok` und
// `/d/:dok/s/:n` das Dokument als Schlüssel; alles andere behält den Pfad.
//
// Einen gefangenen Absturz vergisst der Korb trotzdem bei jedem Wegwechsel (Prop
// `zuruecksetzenBei` = Pfad + Suche, componentDidUpdate) — sonst sperrte eine einzige kaputte
// Seite das ganze Dokument, bis man es verlässt (Review E26).

/** `/d/ROT28-D01/s/7` → `/d/ROT28-D01`; `/d/ROT28-D01` bleibt; jeder andere Pfad bleibt. */
export function bildschirmSchluessel(pfad: string): string {
  const m = /^\/d\/([^/]+)(?:\/s\/[^/]*)?\/?$/.exec(pfad);
  return m ? `/d/${m[1]}` : pfad;
}
